import {
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ChatService } from './chat.service';
import { Chat } from './types/chat.type';

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    providers: [ChatService],
    styles: [
        `
            :host {
                @apply block h-full w-full;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ChatComponent implements OnInit, OnDestroy {
    @Input()
    public scheme: 'guide' | 'tournament';

    @ViewChild('scrollContainer')
    private scrollContainer?: ElementRef<HTMLDivElement>;

    public prompt: string = '';

    /**
     * Controls visibility of the sliding chat panel.
     * When false, only the chat list is visible.
     */
    public isPanelOpen = false;

    public constructor(public readonly chatService: ChatService) {}

    public ngOnInit(): void {
        this.chatService.start(this.scheme, () => {
            setTimeout(() => this.scrollToBottom());
        });
    }

    public ngOnDestroy(): void {
        this.chatService.stop();
    }

    public checkIfEnter(event: KeyboardEvent): void {
        if (event.code !== 'Enter') return;
        this.sendMessage();
    }

    public sendMessage(): void {
        this.chatService.sendMessage(this.prompt);
        this.prompt = '';
    }

    public startNewChat(): void {
        // Clear any existing selection but keep the panel open for a fresh conversation.
        this.chatService.deselectChat();
        this.isPanelOpen = true;
        setTimeout(() => this.scrollToBottom());
    }

    public openChat(chat: Chat): void {
        this.chatService.selectChat(chat);
        this.isPanelOpen = true;
        setTimeout(() => this.scrollToBottom());
    }

    public closeChatPanel(): void {
        this.isPanelOpen = false;
    }

    private scrollToBottom(): void {
        if (!this.scrollContainer) return;
        const element = this.scrollContainer.nativeElement;
        element.scrollTop = element.scrollHeight;
    }
}
